<template>
  <div class="shop-menu-categories" v-if="categories">
    <div class="row">
      <div
        class="left-caret icon has-text-dark"
        @click="showCategoryList = true"
      >
        <i class="fa fa-caret-down" />
      </div>
      <div class="right-btn icon has-text-grey">
        <i v-if="showSearch" class="fa fa-times" @click="closeSearch" />
        <i v-else class="fa fa-search" @click="openSearch" />
      </div>
      <!-- <div v-show="showSearch" class="menu-tags tags">
        <span class="tag">Vegan</span>
        <span class="tag">Gluten Free</span>
      </div>-->
      <slide-x-right-transition>
        <div v-show="showSearch" class="search">
          <i class="fa fa-search has-text-grey left-btn" />
          <input
            ref="search"
            class="input is-white"
            type="text"
            v-model="searchVal"
            :placeholder="searchPlaceholder"
            @keyup="search($event.target.value, true)"
            @focus="search($event.target.value)"
          />
          <!-- @blur="closeSearch"  @blur="clearSearch" -->
          <!-- <div class="enter icon has-text-link" @click="$emit('enter')">
            <i class="fa fa-chevron-right" :class="{ 'has-text-white': !searchVal }" />
          </div> -->
        </div>
      </slide-x-right-transition>
      <div ref="scrollable" class="card-content single-line no-scrollbar">
        <span
          v-if="hasSpecials"
          class="category"
          :class="{ selected: selected === 'Specials' }"
          @click="chooseCategory('Specials')"
        >
          <i
            class="fa fa-star fa-sm"
            :class="{ 'highlight-star': selected === 'Specials' }"
          />
          {{ $t("menu.specials") }}
        </span>
        <span
          v-for="c in activeCategories"
          :key="c.name"
          :ref="c.name"
          class="category"
          :class="{ selected: selected === c.name }"
          @click="chooseCategory(c.name)"
          >{{ c[lang] || c.name }}</span
        >
        <span style="margin: 0 30px" />
      </div>
    </div>

    <fade-transition>
      <div v-if="showCategoryList" class="category-list no-scrollbar">
        <!-- v-on:scroll.passive="onCategoryListScroll" -->
        <p class="category-list-header" @click="showCategoryList = false">
          <i class="fa fa-chevron-left" style="margin-right: 6px" />
          {{ $t("shop.categories") }}
        </p>
        <p v-if="hasSpecials" @click="chooseCategory('Specials')">
          <i style="display: inline-block; width: 12px" />
          <span style="color: #555">
            <i class="fa fa-star fa-sm" /> {{ $t("menu.specials") }}
          </span>
        </p>
        <p
          v-for="c in activeCategories"
          :key="c.name"
          class="single-line no-scrollbar"
          @click="chooseCategory(c.name)"
        >
          <i style="display: inline-block; width: 12px" />
          <span style="color: #555">{{ c[lang] || c.name }}</span>
        </p>
      </div>
    </fade-transition>
  </div>
</template>



<script>
export default {
  name: "ShopMenuCategories",
  components: {},
  props: {
    categories: Object,
    lang: String,
    hasSpecials: Boolean,
    items: Array, // items in menu, used to filter unused categories
    searchParam: String, // url param
  },
  data() {
    return {
      selected: null, // selected category name, e.g. Drinks
      showSearch: false,
      //   showEnter: false,
      searchVal: null,
      searchPlaceholder: this.$t("menu.search-menu"),
      showCategoryList: false,
    };
  },
  computed: {
    activeCategories() {
      var itemCats = this.items.map((i) => i.category).filter((cat) => cat);
      console.log("itemCats", itemCats);
      var allCats = this.categories.data;
      console.log("allCats", allCats);
      var filtered = allCats.filter((o) => {
        return itemCats.includes(o.name);
      });
      return filtered; //this.categories.data;
    },
  },
  mounted() {
    if (this.searchParam) this.setSearchFromParent(this.searchParam);
  },
  methods: {
    // onCategoryListScroll(e) {
    //   // not working, I'm trying to stop the menu scroll under the category list
    //   e.stopPropagation();
    //   e.preventDefault();
    //   e.returnValue = false;
    // },
    class(cat) {
      if (this.selected === cat) return "selected";
      return "not-selected";
    },
    // called by parent
    setCategory(cat) {
      this.selected = cat; // gets called by parent, on scroll event
      if (!cat) return; // null cat if not set
      this.scrollLeft(cat);
    },
    // user selected from this component
    chooseCategory(cat) {
      this.log("choose_category", cat);
      this.scrollLeft(cat, true);
      this.selected = cat;
      this.showCategoryList = false; // hide this if it was open
      this.$emit("setCategory", cat); // emit to parent
    },
    scrollLeft(cat, smooth) {
      if (cat === "Specials") {
        var opts = { left: 0, behavior: "smooth" };
        this.$refs.scrollable.scrollTo(opts);
        return;
      }
      if (!this.$refs[cat]) return; // means cat does not exist, need to fix in menu_editor
      // console.log("scrollLeft", cat, this.$refs[cat]);
      // var left = this.$refs[cat][0].offsetLeft - 10;
      var left = this.$refs[cat][0].offsetLeft - 34;
      var options = { left: left };
      if (smooth) options.behavior = "smooth";
      this.$refs.scrollable.scrollTo(options);
    },
    openSearch() {
      this.showSearch = true;
      this.$nextTick(() => this.$refs.search.focus());
      //   this.showEnter = false;
      //   setTimeout(() => (this.showEnter = true), 2000);
    },
    closeSearch() {
      this.showSearch = false;
      this.clearSearch();
    },
    clearSearch() {
      this.searchVal = null;
      this.search(""); // clear search with blank string, not null
    },
    search(txt, scroll) {
      this.searchVal = txt;
      this.$emit("searchMenu", txt.toLowerCase()); // emit to parent
      if (scroll) this.$emit("enter");
    },
    setSearchFromParent(txt) {
      this.search(txt, true);
      this.showSearch = true;
    },
  },
};
</script>



<style scoped>
.row {
  position: relative;
  width: 100%;
  background-color: white;
  border-bottom: 1px solid #ddd;
  margin-top: 1px;
}
.card-content {
  padding: 9px;
  padding-left: 35px;
  text-align: left;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  overflow-y: hidden;
}
span {
  font-size: 1.2em;
  color: rgba(109, 109, 109, 0.7);
  font-weight: 400;
  padding: 2px 12px;
}
.selected {
  color: #3273dc;
  /* border-bottom: 3px solid #3273dcd4;
  border-radius: 3px; */
  border-bottom: 12px solid #3273dc42;
}
.right-btn {
  height: 46px;
  width: 46px;
  position: absolute;
  right: 0;
  padding: 16px;
  background-color: white;
  /* border: 1px solid #eee;
  border-right: initial;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px; */
}
.left-caret {
  height: 46px;
  width: 30px;
  position: absolute;
  left: 0;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(3px);
}
.left-btn {
  height: 46px;
  width: 46px;
  padding: 16px;
  background-color: white;
}
.search {
  text-align: left;
  position: absolute;
  width: 100%;
  box-shadow: 0 3px 3px grey;
}
input {
  height: 46px;
  /* width: calc(100vw - 136px); */
  width: calc(100% - 92px);
  font-size: 1.2em;
  font-weight: 500;
  /* color: #3273dc; */
  border: none;
  border-radius: 0;
}
.enter {
  background-color: white;
  padding: 20px;
}
.fa-chevron-right {
  padding: 20px;
  z-index: 2;
  font-size: 1.2em;
  margin-top: 4px;
}
span {
  cursor: pointer;
}
.highlight-star {
  text-shadow: 1px 1px 3px rgba(0, 64, 255, 0.9);
  /* color: yellow; */
  background-color: #3273dcae;
  color: rgb(255, 242, 0);
  border-radius: 2px;
  padding: 3px;
}
/* .menu-tags {
  width: 100%;
  padding: 10px;
  position: absolute;
  top: 40px;
  background-color: burlywood;
  border-radius: 10px;
} */
.category-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  min-height: 100vh;
  /* background-color: rgba(255, 255, 255, 0.95); */
  background-color: white;
  text-align: left;
  backdrop-filter: blur(4px);
  padding-bottom: 400px;
  overflow-y: scroll;
}
.category-list p {
  padding: 6px 12px;
  /* color: grey !important; */
}
.category-list-header {
  position: sticky;
  top: 0;
  font-size: 1.2em;
  font-weight: 500;
  color: #aaa;
  /* margin-top: 9px; */
  margin-top: 6px;
  background-color: white;
}
.fa-times {
  z-index: 22;
}
</style>